// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AbatinaRouteImport } from './routes/abatina'
import { Route as ChiSiamoRouteImport } from './routes/chi-siamo'
import { Route as ContattiRouteImport } from './routes/contatti'
import { Route as CookieRouteImport } from './routes/cookie'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RichiesteRouteImport } from './routes/richieste'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as ProdottiIndexRouteImport } from './routes/prodotti.index'
import { Route as ProdottiSlugRouteImport } from './routes/prodotti.$slug'
import { Route as RicetteIndexRouteImport } from './routes/ricette.index'
import { Route as RicetteSlugRouteImport } from './routes/ricette.$slug'
import { Route as AdminCaratteristicheIndexRouteImport } from './routes/admin.caratteristiche.index'
import { Route as AdminOfferteIndexRouteImport } from './routes/admin.offerte.index'
import { Route as AdminPrenotazioniIndexRouteImport } from './routes/admin.prenotazioni.index'
import { Route as AdminProdottiIndexRouteImport } from './routes/admin.prodotti.index'
import { Route as AdminRicetteIndexRouteImport } from './routes/admin.ricette.index'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AbatinaRoute = AbatinaRouteImport.update({
            id: '/abatina',path: '/abatina',getParentRoute: () => rootRouteImport
          })
const ChiSiamoRoute = ChiSiamoRouteImport.update({
            id: '/chi-siamo',path: '/chi-siamo',getParentRoute: () => rootRouteImport
          })
const ContattiRoute = ContattiRouteImport.update({
            id: '/contatti',path: '/contatti',getParentRoute: () => rootRouteImport
          })
const CookieRoute = CookieRouteImport.update({
            id: '/cookie',path: '/cookie',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RichiesteRoute = RichiesteRouteImport.update({
            id: '/richieste',path: '/richieste',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const ProdottiIndexRoute = ProdottiIndexRouteImport.update({
            id: '/prodotti/',path: '/prodotti/',getParentRoute: () => rootRouteImport
          })
const ProdottiSlugRoute = ProdottiSlugRouteImport.update({
            id: '/prodotti/$slug',path: '/prodotti/$slug',getParentRoute: () => rootRouteImport
          })
const RicetteIndexRoute = RicetteIndexRouteImport.update({
            id: '/ricette/',path: '/ricette/',getParentRoute: () => rootRouteImport
          })
const RicetteSlugRoute = RicetteSlugRouteImport.update({
            id: '/ricette/$slug',path: '/ricette/$slug',getParentRoute: () => rootRouteImport
          })
const AdminCaratteristicheIndexRoute = AdminCaratteristicheIndexRouteImport.update({
            id: '/admin/caratteristiche/',path: '/admin/caratteristiche/',getParentRoute: () => rootRouteImport
          })
const AdminOfferteIndexRoute = AdminOfferteIndexRouteImport.update({
            id: '/admin/offerte/',path: '/admin/offerte/',getParentRoute: () => rootRouteImport
          })
const AdminPrenotazioniIndexRoute = AdminPrenotazioniIndexRouteImport.update({
            id: '/admin/prenotazioni/',path: '/admin/prenotazioni/',getParentRoute: () => rootRouteImport
          })
const AdminProdottiIndexRoute = AdminProdottiIndexRouteImport.update({
            id: '/admin/prodotti/',path: '/admin/prodotti/',getParentRoute: () => rootRouteImport
          })
const AdminRicetteIndexRoute = AdminRicetteIndexRouteImport.update({
            id: '/admin/ricette/',path: '/admin/ricette/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AbatinaRoute: AbatinaRoute,ChiSiamoRoute: ChiSiamoRoute,ContattiRoute: ContattiRoute,CookieRoute: CookieRoute,PrivacyRoute: PrivacyRoute,RichiesteRoute: RichiesteRoute,AdminLoginRoute: AdminLoginRoute,ProdottiSlugRoute: ProdottiSlugRoute,RicetteSlugRoute: RicetteSlugRoute,AdminIndexRoute: AdminIndexRoute,ProdottiIndexRoute: ProdottiIndexRoute,RicetteIndexRoute: RicetteIndexRoute,AdminCaratteristicheIndexRoute: AdminCaratteristicheIndexRoute,AdminOfferteIndexRoute: AdminOfferteIndexRoute,AdminPrenotazioniIndexRoute: AdminPrenotazioniIndexRoute,AdminProdottiIndexRoute: AdminProdottiIndexRoute,AdminRicetteIndexRoute: AdminRicetteIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)